import { ToggleIcon } from '../index';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { ChangeEvent, useState } from 'react';
import { Input } from '../Input';
import { IconButton } from '../IconButton';

interface Props {
  disabled?: boolean;
  error?: boolean;
  errorHelper?: string;
  label: string;
  name: string;
  onChange(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
  value: string;
}

export const PasswordField = ({
  disabled = false,
  error = false,
  errorHelper = undefined,
  label,
  name,
  onChange,
  value,
}: Props) => {
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordVisibility = () => {
    setShowPassword((showPassword) => !showPassword);
  };

  return (
    <Input
      fullWidth
      id={name}
      error={error}
      disabled={disabled}
      helperText={error ? errorHelper : undefined}
      endAdornment={
        <IconButton
          className="!p-0 !bg-transparent"
          onClick={handlePasswordVisibility}
        >
          <ToggleIcon
            on={showPassword}
            onIcon={<Visibility />}
            offIcon={<VisibilityOff />}
          />
        </IconButton>
      }
      variant="contained"
      label={label}
      name={name}
      onChange={onChange}
      required
      type={showPassword ? 'text' : 'password'}
      value={value}
    />
  );
};
